<template>
  <div class="shipping">

    <!-- Header -->
    <div class="shipping-line" :class="{ activated: addressFormDisplayed }">
      <h1 class="shipping-line-title"> {{ $t('Delivery address') }} </h1>
      <a v-if="addressFormDisplayed" class="shipping-line-link" @click.stop="closeAddressForm"> {{ $t('Cancel') }} </a>
    </div>
    <!---->

    <!-- Location cards -->
    <section class="shipping-block" v-if="!addressFormDisplayed">
      <!-- Add new card button -->
      <div class="shipping-block-actions add-btn">
        <button class="shipping-block-actions-btn" @click="$bus.$emit('customer-display-shipping-address-form', { type: 'add' })">
          {{ $t('Add a new address') }}
        </button>
      </div>
      <!---->

      <!-- Cards -->
      <address-list />
      <!---->

    </section>
    <!---->

    <!-- Address form -->
    <section class="shipping-block" v-else>
      <address-form ref="address_form" />
      <div class="shipping-block-actions">
        <button-full class="shipping-block-actions-btn" @click.native="submit">
          {{ fieldsType === 'add' ? $t('Add address') : $t('Confirm changes') }}
        </button-full>
      </div>
      <!---->
    </section>
    <!---->
  </div>
</template>

<script async>
import MyShippingDetails from '@vue-storefront/core/compatibility/components/blocks/MyAccount/MyShippingDetails'

const ButtonFull = () => import(/* webpackChunkName: "vsf-button-full" */ 'theme/components/theme/ButtonFull');
const AddressList = () => import(/* webpackChunkName: "vsf-address-list" */ 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressList');
const AddressForm = () => import(/* webpackChunkName: "vsf-address-form" */ 'theme/components/core/blocks/Form/Customer/Shipping/AddressForm');

export default {
  components: {
    ButtonFull,
    AddressList,
    AddressForm
  },
  mixins: [MyShippingDetails]
}
</script>

<style lang="scss" scoped>
  .shipping {
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 576px) {
      padding: 0 20px;
    }

    &-line {
      height: 60px;
      margin-bottom: 20px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      &.activated {
        height: 60px;
        margin-bottom: 20px;
      }

      @media only screen and (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }

      @media only screen and (max-width: 576px) {
        height: 0px;
        margin-bottom: 0;
      }

      &-title {
        margin: 0;

        color: #111;
        font-size: 20px;
        font-weight: 600;

        @media only screen and (max-width: 576px) {
          display: none;
        }
      }

      &-link {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;

        @media only screen and (max-width: 768px) {
          font-size: 14px;
        }

        &-icon {
          padding-left: 10px;
        }
      }
    }

    &-block {
      &-nothing {
        width: 100%;
        margin-top: 10px;
        text-align: center;

        &-text {
          color: #111;
          font-size: 18px;
          font-weight: 400;
        }
      }

      &-actions {
        display: flex;
        justify-content: center;

        @media only screen and (max-width: 576px) {
          margin-top: 20px;
        }

        &.add-btn {
          justify-content: flex-start;

          & .shipping-block-actions-btn {
            padding-left: 98px;
            margin-bottom: 20px;

            background-image: url('../../../../assets/account/icon-location-active.png');
            background-position: 70px center;
            background-size: 15px 18px;
            background-repeat: no-repeat;

            @media only screen and (max-width: 768px) {
              width: 100%;
              padding: 16px 0 16px 20px;
              background-position: 50px center;
            }

            @media only screen and (max-width: 576px) {
              width: auto;
              padding: 16px 84px 16px 98px;
              background-position: 70px center;
            }

            @media only screen and (max-width: 371px) {
              width: 100%;
              padding: 16px 0;
              background-size: 0;
            }
          }
        }

        &-btn {
          width: auto;
          padding: 16px 84px;

          color: #fff;
          font-size: 16px;
          font-weight: 400;

          background-color: #11bb2e;
          border: none;
          border-radius: 5px;

          outline: none;

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, 0.8);
          }
        }
      }

      &-field {
        padding: 0;
      }
    }
  }
</style>
<style lang="scss">
.create-address {
  width: 100%;
  padding: 0!important;
  .vti__dropdown {
    left: 5px;
  }
}
</style>
